module.exports = __webpack_public_path__ + "media/images/app/products/index/types/earrings-32c5b74156a84325a7d41ed1d739ec99.webp";